class ChangePasswordController {
  constructor($mdDialog, $mdToast, ChangePassword, user) {
    this.$mdDialog = $mdDialog;
    this.ChangePassword = ChangePassword;
    this.user = user;
    this.$mdToast = $mdToast;
  }
  close() {
    const { $mdDialog } = this;
    $mdDialog.hide();
  }
  async changePassword(password) {
    const { ChangePassword, user, $mdToast } = this;
    try {
      await ChangePassword.change({ user, password });
      $mdToast.show($mdToast.simple().textContent('clave cambiada exitosamente'));
      this.close();
    } catch (error) {
      $mdToast.show($mdToast.simple().textContent(`Ha ocurrido un error "${error.data.message}"`));
    }
  }
}
ChangePasswordController.$inject = ['$mdDialog', '$mdToast', 'ChangePassword', 'user'];
export default ChangePasswordController;



// WEBPACK FOOTER //
// ./client/app/components/user/userDetails/changePassword/changePassword.controller.js